import script from "./CommonMenuAside.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonMenuAside.vue?vue&type=script&setup=true&lang=js"

import "./CommonMenuAside.vue?vue&type=style&index=0&id=151f3642&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151f3642"]])

export default __exports__